import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { baseUrls } from './appConstant';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  constructor(private httpClient: HttpClient,
    private apiService: ApiService) { }

  promotionalOrLoyalityPointsDiscount(staticUrl: string, data): Observable<any> {
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.post(url, data, {headers: {token: localStorage.getItem('userToken')}}).pipe(
      catchError(this.apiService.handleError));
  }

  getUserSubscriptionDiscount(staticUrl: string): Observable<any> {
    let url= baseUrls['bill']+staticUrl;
    return this.httpClient.get(url, {headers: {token: localStorage.getItem('userToken')}}).pipe(
      catchError(this.apiService.handleError));
  }
  
}

